import create from 'zustand';
import { persist } from 'zustand/middleware';



interface QuoteCopy {
    CopyQuote: any;
    addCopyQuoteInfo: (CopyQuote: any) => void;

    PackagesCopy: {
        value: string;
        label: string;
    };
    PaymentOptionCopy: {
        value: string;
        label: string;
    };

    setPackageCopy: (label: string, value: string) => void;
    setPaymentOptionCopy: (label: string, value: string) => void;
    removeCopyQuoteInfo: () => void;


}


const initialData = {
    CopyQuote:null,
    PackagesCopy: {
        value: 'AMP',
        label: 'Plan Amplio',
    },
    PaymentOptionCopy: {
        value: 'A',
        label: 'Anual',
    },
};



export const useCopyQuoteStore = create<QuoteCopy>(
    //@ts-ignore
    persist(
        (set) => ({
            CopyQuote: initialData.CopyQuote,
            PackagesCopy: initialData.PackagesCopy,
            PaymentOptionCopy: initialData.PaymentOptionCopy,
            setPackageCopy: (label: string, value: string) =>
                set({
                    PackagesCopy: {
                        value,
                        label,
                    },
                }),
            setPaymentOptionCopy: (label: string, value: string) =>
                set({
                    PaymentOptionCopy: {
                        value,
                        label,
                    },
                }),
            addCopyQuoteInfo: (CopyQuote) => {
                set({
                    CopyQuote:CopyQuote,
                });
            },
            removeCopyQuoteInfo: () => {
                set({
                    CopyQuote: initialData.CopyQuote,
                    PackagesCopy: initialData.PackagesCopy,
                    PaymentOptionCopy: initialData.PaymentOptionCopy,
                });
            },
        }),
        {
            name: 'copy-quote-storage',
            getStorage: () => sessionStorage,
        }
    )
);